import { IBingoPlantData } from '@/interfaces/powerMarkets/bingo/IBingoPlantData.ts';
import { ApiPromise, useApi } from '@/api/useApi.ts';

const apiCall = useApi();

function postBingo (payload: { plants: Array<string> }): ApiPromise<Array<IBingoPlantData>> {
    return apiCall.post<{ plants: Array<string>}, Array<IBingoPlantData>>({
        endpoint: '/bingo',
        payload,
    });
}

export const bingoBoardApi = {
    postBingo,
};
